import Button from '@rio-cloud/rio-uikit/Button';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import type { PropsWithId } from 'components/types';

const Title = () => <p className='font-body text-20 text-light leading-24'>Your session has expired</p>;

const Body = () => (
    <div className='text-16'>
        <div className='mb-10 display-flex justify-content-center'>
            <span className='rioglyph rioglyph-time-incomplete text-77 text-gray-light' />
        </div>
        <p className='mb-15'>You need to log in again to keep using the Control Center.</p>
    </div>
);

interface FooterProps {
    onConfirm?: () => void;
}

const Footer = ({ onConfirm }: FooterProps) => (
    <div className='display-flex justify-content-end gap-10'>
        <Button data-testid='session-expired-login-button' onClick={onConfirm} bsStyle={Button.PRIMARY}>
            Go to Log In
        </Button>
    </div>
);

interface Props {
    show: boolean;
    onConfirm?: () => void;
}

// Feedback catalogue row 7: the overlay has no close affordance — no header button, no Esc, no
// backdrop click. Logging in again is the only way out.
const TimeoutDialog = ({ show, onConfirm, id }: PropsWithId<Props>) => (
    <Dialog
        {...(id ? { 'data-testid': `timeout-dialog-${id}` } : {})}
        show={show}
        title={<Title />}
        footer={<Footer onConfirm={onConfirm} />}
        body={<Body />}
        showCloseButton={false}
        disableEsc
        bsSize={Dialog.SIZE_SM}
    />
);

export default TimeoutDialog;
